import React from 'react';
import { Warning } from '@phosphor-icons/react';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

export const EmployeesDuplicatesPanel = ({
  duplicates, show, onDismiss, onMerge,
}) => {
  if (!show || !duplicates || duplicates.total_duplicate_groups === 0) return null;
  return (
    <Card className="border-amber-200 bg-amber-50">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <CardTitle className="text-base text-amber-800 flex items-center gap-2">
          <Warning size={20} weight="fill" className="text-amber-600" />
          {duplicates.total_duplicate_groups} Duplicate Group
          {duplicates.total_duplicate_groups > 1 ? 's' : ''} Found
        </CardTitle>
        <Button variant="ghost" size="sm" onClick={onDismiss} className="text-amber-700">
          Dismiss
        </Button>
      </CardHeader>
      <CardContent className="max-h-48 overflow-y-auto space-y-3">
        {duplicates.by_name.map((group, i) => (
          <div
            key={`n-${i}`}
            className="bg-white rounded-lg p-3 border border-amber-200 flex items-start justify-between"
          >
            <div>
              <p className="text-xs font-semibold text-amber-700 mb-1">
                Name: <span className="capitalize">{group.match_value}</span>{' '}
                ({group.count} records)
              </p>
              <div className="flex flex-wrap gap-2">
                {group.employees.map((e) => (
                  <Badge key={e.id} variant="outline" className="text-xs bg-white">
                    {e.first_name} {e.last_name} ({e.employee_id}) - {e.status || 'Active'}
                  </Badge>
                ))}
              </div>
            </div>
            <Button
              size="sm"
              variant="outline"
              className="ml-3 shrink-0 text-indigo-700 border-indigo-300 hover:bg-indigo-50"
              onClick={() => onMerge(group)}
              data-testid={`merge-emp-name-${i}`}
            >
              Merge
            </Button>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default EmployeesDuplicatesPanel;
